import { Button } from 'antd';

import ByModal from '@/components/ByModal';
import { useI18nContext } from '@/i18n/I18n';
import { ERROR_CODE } from '@/utils/constants/sub-account';

// 非当前站点账号登录的提示
export const ErrorLoginModal = ({
  showErrorTip,
  errorCode,
  onClose,
}: {
  showErrorTip: boolean;
  errorCode: number;
  onClose: () => void;
}) => {
  const [$t] = useI18nContext();

  const ByFooter = () => {
    return (
      <div>
        <Button type="primary" onClick={onClose}>
          {$t('Confirm')}
        </Button>
      </div>
    );
  };
  const imgSrc = [
    ERROR_CODE.HK_USER_LOGIN_BYBIT,
    ERROR_CODE.BYBIT_USER_LOGIN_HK,
  ].includes(errorCode)
    ? '/bycsi-root/bybit/deadpool/image-88a487697968406faa1aa1918f1287e8.svg'
    : '/bycsi-root/bybit/deadpool/image-84f00a214fb54eacbc2ec92086433b3f.svg';

  return (
    <ByModal
      visible={showErrorTip}
      title={null}
      ByFooter={<ByFooter />}
      onCancel={onClose}
    >
      <div className="text-center text-[20px] font-semibold flex flex-col items-center">
        <img
          src={imgSrc}
          alt="warning"
          width={66}
          style={{ marginBottom: 16 }}
        />
        {$t(errorCode?.toString(), { ns: 'inverse-error-code' })}
      </div>
    </ByModal>
  );
};
